import styles from "./Notification.module.css";
import SingleNotification from "./SingleNotification";
import NoNotification from "./NoNotification";
import { useDispatch, useSelector } from "react-redux";
import { toggleNotification } from "../../store/actions";
import { collection, getDocs } from "firebase/firestore";
import { useEffect, useState } from "react";
import { BellSvg } from "../Common";
import db from "../../firebase";

const Notification = () => {
  const dispatch = useDispatch();
  const notification = useSelector((state) => state.notification);
  const loggedUser = useSelector((state) => state.loggedUser);
  const [notifications, setNotifications] = useState([]);
  const [ring, setRing] = useState(false);

  useEffect(() => {
    async function getNotifications() {
      if (!loggedUser.uid) {
        return;
      }
      const collectionn = await getDocs(
        collection(db, `user_data/${loggedUser.uid}/notifications`)
      );
      const tempData = [];
      collectionn.forEach((doc) => {
        tempData.push({
          id: doc.data().id,
          msg: doc.data().msg,
          read_status: doc.data().read_status,
          time: doc.data().time,
        });
      });
      setNotifications(tempData);
      if (tempData.find((item) => item.read_status === false)) {
        setRing(true);
        return setTimeout(() => setRing(false), 2000);
      }
    }
    const interval = setInterval(() => getNotifications(), 1000);
    return () => clearInterval(interval);
  }, [loggedUser]);

  return (
    <>
      <button
        className={`${styles.mainIcon} ${ring === true && styles.ring} ${
          notification && styles.active
        } ${
          notifications.find((item) => item.read_status === false) &&
          styles.newNotification
        }`}
        onClick={() => {
          dispatch(toggleNotification());
        }}
      >
        <BellSvg color="#fff" size="20px" />
      </button>
      {notification && (
        <div className={styles.notificationPanelOuter}>
          <div className={styles.notificationBlankBox}></div>
          <div className={styles.notificationMainBox}>
            {notifications && notifications.length > 0 ? (
              notifications
                .sort((a, b) => {
                  return b.time.seconds - a.time.seconds;
                })
                .map((item, index) => (
                  <SingleNotification
                    key={index}
                    data={item}
                    notifications={notifications}
                    setNotifications={setNotifications}
                  />
                ))
            ) : (
              <NoNotification />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Notification;
